// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__27cby","infoBtn":"quickbooks_infoBtn__1Phe_","formBox":"quickbooks_formBox__1LKuO","formFooter":"quickbooks_formFooter__1BiSB"};